import {Head, usePage} from '@inertiajs/react'
import Layout from "../../components/layout";
import InstallPWA from '../../components/installPWA.jsx';
import {useEffect} from 'react';
import toast from 'react-hot-toast';

export default function Join({eventName, coverUrl, organizerName, loginLink, recaptchaKey}) {
    const {flash} = usePage().props;

    useEffect(() => {
        if (flash?.message){
            toast.error(flash.message)
        }
    }, [flash?.message]);

    return (
        <Layout>
            <Head title={eventName}/>
            <div className="relative full-screen">
                <img className="absolute object-cover inset-0 w-full h-full -z-10" src={coverUrl} alt="Cover image"/>
                <div className="flex h-full flex-col flex-grow full-screen bg-gradient-to-b from-transparent via-transparent to-black">
                    <div className="flex flex-grow"></div>
                    <div className="flex flex-col px-[20px] pb-[20px]">
                        <h1 className="text-white text-[40px] font-bold">{eventName}</h1>
                        <p className="text-white">{organizerName}</p>
                        <InstallPWA loginLink={loginLink} recaptchaKey={recaptchaKey} />
                    </div>
                </div>
            </div>
        </Layout>
    )
}
